
const clearAllInAppMessage = (dispatch: any) => {
  dispatch({
    type: 'ptrui_updateInAppMessages',
    ptrui_updateInAppMessages: []
  })
}

export default clearAllInAppMessage;